var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkedinV2 = function SvgLinkedinV2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3.75,
    width: 52.5,
    height: 52.5,
    rx: 26.25,
    fill: "#1275B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6598 18.1728C23.6598 19.9251 22.141 21.3456 20.2674 21.3456C18.3938 21.3456 16.875 19.9251 16.875 18.1728C16.875 16.4205 18.3938 15 20.2674 15C22.141 15 23.6598 16.4205 23.6598 18.1728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3389 23.6777H23.1379V41.25H17.3389V23.6777Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4742 23.6777H26.6753V41.25H32.4742C32.4742 41.25 32.4742 35.718 32.4742 32.2591C32.4742 30.183 33.1831 28.0979 36.0116 28.0979C39.2082 28.0979 39.1889 30.8147 39.174 32.9195C39.1545 35.6708 39.201 38.4785 39.201 41.25H45V31.9757C44.9509 26.0538 43.4078 23.3252 38.3312 23.3252C35.3164 23.3252 33.4476 24.6939 32.4742 25.9322V23.6777Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinV2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin-v2.3effe947fa257789d23143305fb3b30e.svg";